import Axios from "axios";
import AiUsageBreakdownRow from "../domain/AiUsageBreakdownRow";
import AiUsageDailyGroupedPoint from "../domain/AiUsageDailyGroupedPoint";
import AiUsageDailyPoint from "../domain/AiUsageDailyPoint";
import AiUsageSummary from "../domain/AiUsageSummary";

export type AiUsageGroupBy = "organization" | "model" | "ai_configuration_kind" | "ai_extractor" | "ai_report_summarizer" | "source" | "source_organization";
export type AiUsageDailyGroupBy = "model" | "organization";
export type AiUsageTimePeriod = "day" | "month";

export interface AiUsageQuery {
    dateFrom?: string;
    dateTo?: string;
    organizationId?: string;
    period?: AiUsageTimePeriod;
}

class AiUsageService {

    readonly basePath = "/ai-usage";

    public getSummary(query: AiUsageQuery): Promise<AiUsageSummary> {
        return Axios.get(`${this.basePath}/summary?${this.toQueryParams(query)}`)
            .then(value => AiUsageSummary.fromPOJO(value.data));
    }

    public getDaily(query: AiUsageQuery): Promise<AiUsageDailyPoint[]> {
        return Axios.get(`${this.basePath}/daily?${this.toQueryParams(query)}`)
            .then(value => value.data.map((item: any) => AiUsageDailyPoint.fromPOJO(item)));
    }

    public getDailyGrouped(query: AiUsageQuery, groupBy: AiUsageDailyGroupBy): Promise<AiUsageDailyGroupedPoint[]> {
        const queryParams = this.toQueryParams({...query, groupBy});

        return Axios.get(`${this.basePath}/daily-grouped?${queryParams}`)
            .then(value => value.data.map((item: any) => AiUsageDailyGroupedPoint.fromPOJO(item)));
    }

    public getBreakdown(query: AiUsageQuery, groupBy: AiUsageGroupBy): Promise<AiUsageBreakdownRow[]> {
        const queryParams = this.toQueryParams({...query, groupBy});

        return Axios.get(`${this.basePath}/breakdown?${queryParams}`)
            .then(value => value.data.map((item: any) => AiUsageBreakdownRow.fromPOJO(item)));
    }

    private toQueryParams(query: AiUsageQuery & { groupBy?: AiUsageGroupBy | AiUsageDailyGroupBy }): string {
        const params = new URLSearchParams();

        if (query.dateFrom) {
            params.set("dateFrom", query.dateFrom);
        }

        if (query.dateTo) {
            params.set("dateTo", query.dateTo);
        }

        if (query.organizationId) {
            params.set("organizationId", query.organizationId);
        }

        if (query.period) {
            params.set("period", query.period);
        }

        if (query.groupBy) {
            params.set("groupBy", query.groupBy);
        }

        return params.toString();
    }
}

export default AiUsageService;
